import * as angular from 'angular';
import { ConfigService } from './ConfigModule';

export class ApiService {
    static $inject = ['$http', '$config']
    apiBase: string;

    constructor(private $http: angular.IHttpService, private $config: ConfigService) {
    }

    get<T>(url: string, config?: angular.IRequestShortcutConfig): angular.IHttpPromise<T> {
        return this.$http.get<T>(this.$config.apiBase + url, config)
    }

    post<T>(url: string, data: any, config?: angular.IRequestShortcutConfig): angular.IHttpPromise<T> {
        return this.$http.post<T>(this.$config.apiBase + url, config);
    }
}

export default angular.module('services.api', [])
    .service('$api', ApiService)
    .name;